import {
  ArticlesSearchResponse,
  DocumentsSearchResponse,
  ProductsSearchResponse,
  SearchRequest,
  SearchResponse,
} from '@api/types';
import { api } from './api';

const getSearchQueryDefinition = (endpointName: string) => ({
  query: (body: SearchRequest) => ({
    method: 'POST',
    url: `api/content/${endpointName}`,
    body,
  }),
});

export const searchApi = api.injectEndpoints({
  endpoints: (builder) => ({
    fullSearch: builder.query<SearchResponse, SearchRequest>({
      query: (body) => ({
        method: 'POST',
        url: `api/content/full-search`,
        body,
      }),
    }),
    searchArticles: builder.query<ArticlesSearchResponse, SearchRequest>(
      getSearchQueryDefinition('articles-search')
    ),
    searchDocuments: builder.query<DocumentsSearchResponse, SearchRequest>(
      getSearchQueryDefinition('documents-search')
    ),
    searchProducts: builder.query<ProductsSearchResponse, SearchRequest>(
      getSearchQueryDefinition('products-search')
    ),
    searchAccessories: builder.query<ProductsSearchResponse, SearchRequest>(
      getSearchQueryDefinition('accessories-search')
    ),
  }),
  overrideExisting: false,
});

export const {
  useFullSearchQuery,
  useLazyFullSearchQuery,
  useLazySearchArticlesQuery,
  useLazySearchDocumentsQuery,
  useLazySearchProductsQuery,
  useLazySearchAccessoriesQuery,
} = searchApi;
